/*
 *  Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .controller('ShareGroupsController', [
        '$document',
        '$scope',
        '$translate',
        'ElementsThatKeepTheSelectedState',
        'headerService',
        'ShareGroupsResource',
        function (
            $document,
            $scope,
            $translate,
            ElementsThatKeepTheSelectedState,
            headerService,
            ShareGroupsResource
        ) {
            headerService.addBreadcrumbsRootItem($translate.instant('share_groups_section_title'), null);

            Object.defineProperties($scope, {
                selectedGroupUUID: {
                    value: '',
                    writable: true
                },
                selectedGroup: {
                    get() {
                        return $scope.selectedGroupUUID ? $scope.table.entries.find(entry => entry.uuid === $scope.selectedGroupUUID) : null;
                    }
                },
                selectGroup: {
                    value: function (groupUUID) {
                        $scope.selectedGroupUUID = $scope.selectedGroupUUID === groupUUID ? '' : groupUUID;
                    }
                },
                clearSelection: {
                    value: function () {
                        $scope.selectedGroupUUID = '';
                    }
                }
            });

            $scope.table = {
                model: ShareGroupsResource,
                perPage: 100,
                supportsSearch: false
            };

            $document.find('body')
                .off('click')
                .on('click', ($event) => {
                    const clickedElement = $($event.target);

                    for (let i in ElementsThatKeepTheSelectedState) {
                        if (clickedElement.is(ElementsThatKeepTheSelectedState[i])) return;
                    }

                    $scope.clearSelection();
                    $scope.$digest();
                });
        }
    ]);
